import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Logo from '../../../../../assets/CC ATS Logo.svg';
import { DContext } from "../../../../../context/Datacontext";
import { RxCheck } from "react-icons/rx";
import { useMemo } from "react";
import { ProgressBar } from '../ProgressBar';
import { IoHome } from "react-icons/io5";
import ResumeViewer from '../../../../blocks/Layout/ResumeViewer';


export const Layout = ({ children, candidate, isResumeParsing }) => {
  const { BeURL, currentUser } = useContext(DContext);
  const navigate = useNavigate();
  const location = useLocation();
  const activelink = location.pathname;


  const navLink = useMemo(() => [
    {
      label: 'Personal Info',
      page: 'personalInformation',
      step: 1,
      progress: !!(candidate?.isPersonalInformation && (candidate?.languages?.length >= 0)),
      processing: "Kickstart Your Profile—Basics That Open Career Doors."
    },
    {
      label: 'Skills & Resume',
      page: 'skills',
      step: 2,
      progress: !!(candidate?.isSkills || (candidate?.skills?.length > 0)),
      processing: "Flex Your Strengths, Skills Get You Shortlisted."
    },

    {
      label: 'Summary & Residential',
      page: 'profilesummery',
      step: 3,
      progress: !!(candidate?.presentAddress?.city),
      processing: "Your Story Matters—Let Recruiters Know Who You Are."
    },
    {
      label: 'Education',
      page: 'education',
      step: 4,
      progress: !!(candidate?.isEducation || (candidate?.educations?.length > 0)),
      processing: "Show Where You’ve Learned, Boosts Trust Instantly."
    },
    {
      label: 'Experience',
      page: 'experience',
      step: 5,
      progress: !!(candidate?.isExperience || (candidate?.experiences?.length > 0) || (candidate?.experiences?.isFresher)),
      processing: "Share What You’ve Done, Every Role Adds Value."
    },
    // {
    //   label: 'Highlights',
    //   page: 'highlights',
    //   step: 6,
    //   progress: !!(
    //     candidate?.iscertifications || candidate?.isProjects || candidate?.isSocial ||
    //     (candidate?.certifications?.length > 0) ||
    //     (candidate?.projects?.length > 0) ||
    //     (candidate?.socialProfiles?.length > 0)
    //   ),
    //   processing: "Stand Out—Achievements Make Your Profile Shine."
    // },
    {
      label: 'Preferences',
      page: 'preferences',
      step: 6,
      progress: !!(candidate?.isPreference || (candidate?.preferredJob?.length > 0)),
      processing: "Tell Us What You Want, Get Jobs Tailored To You."
    }
  ], [candidate]);

  // Default redirect from / to first step
  useEffect(() => {
    if (activelink === "/create-candidate") {
      navigate(`/update-account/personalInformation?candidateId=${candidate?._id}`, { replace: true });
    }
  }, [activelink, navigate, currentUser]);


  useEffect(() => {
    if (!candidate?._id) return;

    const nextStepIndex = navLink.findIndex(nav => !nav.progress);
    const currentStepIndex = navLink.findIndex(nav => `/update-account/${nav.page}` === activelink);
    if (nextStepIndex === -1) return;

    if (currentStepIndex !== -1 && navLink[currentStepIndex].progress === false) {
      const nextNav = navLink[nextStepIndex];
      const nextPath = `/update-account/${nextNav.page}?candidateId=${candidate?._id}`;
      navigate(nextPath);
    }
  }, [candidate?._id, activelink, navLink, navigate, currentUser]);



  // return (
  //   <div className=" h-screen flex justify-center overflow-hidden mt-5 max-w-full">
  //     {/* Sidebar */}
  //     <div className='hidden lg:flex w-1/2 h-full border-r overflow-hidden'>
  //       <ResumeViewer resumeName={candidate?.resumeLink?.split("/").pop()} />
  //     </div>
  //     <div>
  //       <div className="hidden lg:flex  bg-[#f8f8f8] border-r shadow-lg">
  //         <aside className="flex  items-center h-full mt-3">
  //           {/* Logo */}
  //           {/* <div className="sticky top-0 z-10 flex justify-center items-center h-[100px]">
  //           <img src={Logo} alt="Logo" className="w-[130px] h-auto object-contain cursor-pointer rounded-xl" onClick={() => window.location.href = "/"} />
  //         </div> */}

  //           {/* Navigation Steps */}
  //           <div className="flex overflow-y-auto pl-10 py-5 ">
  //             {navLink.map((nav, i) => {
  //               const navPath = `/update-account/${nav.page}?candidateId=${candidate?._id}`;
  //               // Tick mark only if step completed
  //               const showTick = nav.progress === true;
  //               return (
  //                 <div
  //                   key={i}
  //                   className={`flex items-center gap-4 py-2 px-3 rounded-xl mb-2  transition-all duration-200
  //                 ${activelink === `/update-account/${nav.page}`
  //                       ? 'bg-white text-[#2C25C4] shadow-lg cursor-pointer'
  //                       : 'hover:bg-gray-100 text-gray-700 cursor-pointer'
  //                     }

  //                    ${!showTick && activelink !== `/update-account/${nav.page}`
  //                       ? 'opacity-30 pointer-events-none'                      // disable only future steps
  //                       : ''                                                    // allow completed steps
  //                     }`}
  //                   onClick={() => navigate(navPath)}
  //                 >
  //                   <div
  //                     className={`flex items-center justify-center w-5 h-5 rounded-full text-sm font-bold
  //                   ${activelink === `/update-account/${nav.page}`
  //                         ? 'bg-[#2C25C4] text-white shadow-md' // active
  //                         : showTick
  //                           ? 'bg-[#2C25C4] text-white border font-medium border-[#2C25C4] cursor-pointer'
  //                           : 'border border-gray-400 text-gray-600  opacity-30 pointer-events-none'
  //                       }`}

  //                   >
  //                     {showTick ? <span>{i + 1}</span> : `${nav.step}`}
  //                   </div>

  //                   <span
  //                     className={`text-base truncate ${activelink === `/update-account/${nav.page}`
  //                       ? 'text-[#2C25C4]'
  //                       : showTick ? "text-[#2C25C4]" : ""
  //                       }`}
  //                   >
  //                     {nav.label}
  //                   </span>
  //                 </div>
  //               );
  //             })}
  //           </div>
  //           <a className='text-primary-300  px-3 py-1 rounded-lg  font-semibold' href="/"><IoHome className='text-xl'/></a>
  //         </aside>
  //       </div>
  //       {/* Mobile Bottom Navbar */}
  //       <div className='block lg:hidden fixed bottom-0 py-4 bg-white w-full z-50 border-t shadow-lg'>
  //         <div className='flex justify-between px-4'>
  //           {navLink.map((nav, i) => {
  //             const navPath = `/update-account/${nav.page}?candidateId=${candidate._id}`;
  //             const isAllowed = i === 0 ? true : navLink[i - 1].progress === true;
  //             const showTick = nav.progress === true;
  //             const isActive = activelink === `/update-account/${nav.page}`;

  //             return (
  //               <div
  //                 key={i}
  //                 className='flex flex-col items-center cursor-pointer'
  //                 onClick={() => {
  //                   if (isAllowed) navigate(navPath);
  //                   else alert(`Please complete Step ${i} before moving to Step ${i + 1}`);
  //                 }}
  //               >
  //                 <div className={`flex items-center justify-center w-10 h-10 rounded-full text-sm font-bold
  //           ${isActive ? 'bg-[#2C25C4] text-white shadow-md' : 'border border-gray-400 text-gray-600'}
  //            `}>
  //                   {showTick ? <span>{i + 1}</span> : nav.step}
  //                   {/* {showTick ? <RxCheck size={18} /> : nav.step} */}
  //                 </div>
  //               </div>
  //             );
  //           })}
  //         </div>
  //       </div>
  //       {/* Main Content */}
  //       <div className="flex-1 h-full overflow-y-auto px-2 bg-[#ecf1ff] scroll-smooth scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100 ">
  //         <section className="max-w-7xl mx-auto  lg:px-4 w-full py-0 space-y-8">
  //           {/* Header */}
  //           {/* <div className='sticky top-0 z-40 bg-[#ecf1ff] py-4 px-3 w-full'>
  //           <div className='flex items-center justify-between'>
  //             <div className="z-20 w-full pb-2">
  //               {navLink
  //                 .filter(nav => `/update-account/${nav.page}` === activelink)
  //                 .map((value, idx) => (
  //                   <div key={idx}>
  //                     <h2 className="font-semibold text-lg md:text-xl">{value.label}</h2>
  //                     <p className="text-sm mt-1">{value.processing}</p>
  //                   </div>
  //                 ))
  //               }
  //             </div>
  //             <div className='text-center'>
  //               <p className='text-primary-500 text-2xl font-bold'>{candidate?.score ? candidate?.score : 0}%</p>
  //               <p className='truncate text-sm text-gray-500'>Profile Score</p>
  //             </div>
  //           </div>


  //           <div className="w-full bg-gray-200 rounded-full h-2 relative">
  //             <ProgressBar value={candidate?.score} />
  //           </div>
  //         </div> */}

  //           <div>{children}</div>
  //         </section>
  //       </div>
  //     </div>

  //   </div>
  // );

  return (
    <div className="h-screen flex flex-col overflow-hidden  max-w-full">

      {/* Top Navigation */}
      <div className="hidden lg:flex w-full h-[72px] shrink-0 bg-[#f8f8f8] border-b shadow-sm z-40">

        <aside className="flex items-center justify-center w-full px-6">

          {/* Logo */}
          {/* <div className="sticky top-0 z-10 flex justify-center items-center h-[100px]">
                <img src={Logo} alt="Logo" className="w-[130px] h-auto object-contain cursor-pointer rounded-xl" onClick={() => window.location.href = "/"} />
            </div> */}

          {/* Navigation Steps */}
          <div className="flex items-center gap-2 overflow-x-auto py-2 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent">
            {navLink.map((nav, i) => {
              const navPath = `/update-account/${nav.page}?candidateId=${candidate?._id}`;
              // Tick mark only if step completed
              const showTick = nav.progress === true;
              return (
                <div
                  key={i}
                  className={`flex items-center gap-2 py-2 px-3 rounded-xl transition-all duration-200 whitespace-nowrap
                            ${activelink === `/update-account/${nav.page}`
                      ? 'bg-white text-[#2C25C4] shadow-md cursor-pointer'
                      : 'hover:bg-gray-100 text-gray-700 cursor-pointer'
                    }
                            ${!showTick && activelink !== `/update-account/${nav.page}`
                      ? 'opacity-30 pointer-events-none'
                      : ''
                    }`}
                  onClick={() => navigate(navPath)}
                >
                  <div
                    className={`flex items-center justify-center w-8 h-8 rounded-full text-xs font-bold shrink-0
                                ${activelink === `/update-account/${nav.page}`
                        ? 'bg-[#2C25C4] text-white shadow-md'
                        : showTick
                          ? 'bg-[#2C25C4] text-white border font-medium border-[#2C25C4] cursor-pointer'
                          : 'border border-gray-400 text-gray-600 opacity-30 pointer-events-none'
                      }`}
                  >
                    {showTick ? <span>{i + 1}</span> : `${nav.step}`}
                  </div>

                  <span
                    className={`text-sm font-medium  max-w-[130px]
                                ${activelink === `/update-account/${nav.page}`
                        ? 'text-[#2C25C4]'
                        : showTick ? "text-[#2C25C4]" : ""
                      }`}
                  >
                    {nav.label}
                  </span>
                </div>
              );
            })}
          </div>

          {/* Home */}
          <a
            className="flex items-center justify-center w-10 h-10 rounded-xl text-primary-300 hover:bg-white hover:shadow-sm transition-all shrink-0 ml-4"
            href="/"
            title="Home"
          >
            <IoHome className="text-xl" />
          </a>

        </aside>
      </div>

      {/* Mobile Bottom Navbar */}
      <div className="block lg:hidden fixed bottom-0 py-4 bg-white w-full z-50 border-t shadow-lg">
        <div className="flex justify-between px-4">
          {navLink.map((nav, i) => {
            const navPath = `/update-account/${nav.page}?candidateId=${candidate._id}`;
            const isAllowed = i === 0 ? true : navLink[i - 1].progress === true;
            const showTick = nav.progress === true;
            const isActive = activelink === `/update-account/${nav.page}`;

            return (
              <div
                key={i}
                className="flex flex-col items-center cursor-pointer"
                onClick={() => {
                  if (isAllowed) navigate(navPath);
                  else alert(`Please complete Step ${i} before moving to Step ${i + 1}`);
                }}
              >
                <div className={`flex items-center justify-center w-10 h-10 rounded-full text-sm font-bold
                        ${isActive ? 'bg-[#2C25C4] text-white shadow-md' : 'border border-gray-400 text-gray-600'}
                        `}>
                  {showTick ? <span>{i + 1}</span> : nav.step}
                  {/* {showTick ? <RxCheck size={18} /> : nav.step} */}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Main Two Column Content */}
      <div className="flex flex-1 min-h-0 w-full">

        {/* Left - Resume */}
        <div className="hidden lg:flex w-1/2 h-full border-r overflow-hidden bg-gray-100">
          <ResumeViewer candidate={candidate} isResumeParsing={isResumeParsing} />
        </div>

        {/* Right - Form */}
        <div className="w-full lg:w-1/2 h-full overflow-y-auto px-2 bg-[#ecf1ff] scroll-smooth scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100">

          <section className="max-w-7xl mx-auto lg:px-4 w-full py-0 space-y-8">

            {/* Header */}
            {/* <div className='sticky top-0 z-40 bg-[#ecf1ff] py-4 px-3 w-full'>
                    <div className='flex items-center justify-between'>
                        <div className="z-20 w-full pb-2">
                            {navLink
                                .filter(nav => `/update-account/${nav.page}` === activelink)
                                .map((value, idx) => (
                                    <div key={idx}>
                                        <h2 className="font-semibold text-lg md:text-xl">{value.label}</h2>
                                        <p className="text-sm mt-1">{value.processing}</p>
                                    </div>
                                ))
                            }
                        </div>
                        <div className='text-center'>
                            <p className='text-primary-500 text-2xl font-bold'>{candidate?.score ? candidate?.score : 0}%</p>
                            <p className='truncate text-sm text-gray-500'>Profile Score</p>
                        </div>
                    </div>

                    <div className="w-full bg-gray-200 rounded-full h-2 relative">
                        <ProgressBar value={candidate?.score} />
                    </div>
                </div> */}

            <div>
              {children}
            </div>

          </section>
        </div>

      </div>

    </div>
  )
};




